import * as React from "react";

import { IFamilyMember } from '@app-types/websocket/family.types';
import * as TodoActions from '@services/todos/todo.action';
import { connect } from "react-redux";
import { ISchedule } from "@app-types/websocket/schedule.types";
import { ICompleteTodo, IHideTodo, ITodo, RENEWAL, TODO_TYPE } from "@app-types/websocket/todo.types";
import NextHandoverPerSchedule from "./NextHandoverPerSchedule";
import { ICalendarSetting } from "@app-types/websocket/user.types";
import SCHEDULE_TYPES from "@constants/scheduleTypes";

interface IProps {
    myAccountId:number;
    family:IFamilyMember[];
    schedules: ISchedule[];
    todos:ITodo[];
    hide:boolean;
    amountOfSchedules:number;
    seenTodo:(data:IHideTodo) => void;
    completeTodo:(completed:ICompleteTodo) => void;
    completeHandover:(scheduleId:number) => void;
}

const messageStyle: React.CSSProperties = {padding: '12px 20px'};
const singleListStyle: React.CSSProperties = {display: 'flex', flexDirection: 'column', flex: '1 0 auto', paddingTop: '23px'};
const stackedListStyle: React.CSSProperties = {...singleListStyle,
  paddingBottom: 'calc(84px + env(safe-area-inset-bottom, 0px))'};

class NextHandover extends React.Component<IProps> {

  public render() {
    
    if (this.props.amountOfSchedules === 0) {
      return (
        <div style={messageStyle}>You need to create a schedule to use this functionality</div>
      );
    }

    if (this.props.schedules.length === 0) {
      return (
          <div style={messageStyle}>You need to select one schedule to be shown</div>
        );
    }

    return (
        <div style={this.props.schedules.length === 1 ? singleListStyle : stackedListStyle}>
          {
          this.props.schedules.map((schedule:ISchedule) => 
            <NextHandoverPerSchedule
              seenTodo={this.props.seenTodo}
              myAccountId={this.props.myAccountId}
              key={schedule.id}
              hide={this.props.hide}
              single={this.props.schedules.length === 1}
              family={this.props.family}
              schedule={schedule}
              schedules={this.props.schedules}
              todos={this.props.todos.filter((todo:ITodo) => 
                (schedule.id === todo.scheduleId && todo.handovergroup === undefined))}
              completeTodo={this.props.completeTodo}
              completeHandover={() => this.props.completeHandover(schedule.id)}
            />
          )
          }
        </div>
    );
  }
}

function mapStateToProps(state: any) {
  const myAccountId = state.user.session.data.id;
  const todos:ITodo[] = state.todo.todos.filter((todo:ITodo) => todo.type === TODO_TYPE.HANDOVER);

  const schedules:ISchedule[] = state.schedule.schedules.filter(
    (schedule:ISchedule) => (schedule.status !== SCHEDULE_TYPES.DELETED 
      && schedule.status !== SCHEDULE_TYPES.DELETED_WIP));
  const calendarSettings:ICalendarSetting = state.user.calendarSettings;
  const selectedSchedules:ISchedule[] = [];
  
  if (calendarSettings && calendarSettings.calendars) {
    for (const scheduleId of calendarSettings.calendars){
      for (const schedule of schedules) {
        if (scheduleId === schedule.id) {
          selectedSchedules.push(schedule);
        }
      }
    }
  }

  return {
    myAccountId,
    schedules: selectedSchedules,
    amountOfSchedules: schedules?schedules.length:0,
    family: state.family.family,
    todos
  };
}

const mapDispatchToProps = {
  completeTodo: TodoActions.completeTodo,
  seenTodo: TodoActions.seenTodo,
  completeHandover: TodoActions.completeHandover,
};

export default connect(mapStateToProps, mapDispatchToProps)(NextHandover);


// WEBPACK FOOTER //
// ./src/components/next-handover/NextHandover.tsx